<template>
  <v-card width="350px" class="mx-auto mt-0">
    <v-card-title>
      <h1 class="display-1">Register</h1>
    </v-card-title>
    <v-card-text>
      <v-form>
        <v-text-field label="Username" prepend-icon="mdi-account-circle" v-model="name" />
        <v-text-field label="EMail" prepend-icon="mdi-email" v-model="email" />
        <v-text-field
          :type="showPassword ? 'text' : 'password'"
          v-model="password"
          label="Password"
          prepend-icon="mdi-lock"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
        />
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <span class="ml-2">Already registered?</span>
      <Button @click="item.showLogin" class="btn-login">Login</Button>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="register">Register</v-btn>
    </v-card-actions>
    <template v-if="this.error">
      <v-divider></v-divider>
      <p class="aa-error">{{ error }}</p>
    </template>
  </v-card>
</template>


<script>
//import { signinWithEmailAndPassword, signinWithGoogle } from "../../auth";
import { registerWithEmailAndPassword } from "../../auth";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      showPassword: false,
      name: "",
      email: "",
      password: "",
      error: "",
    };
  },
  computed: {},
  name: "DialogClientDetails",
  methods: {
    register() {
      registerWithEmailAndPassword(this.email, this.password, (err) => {
        this.setError(err);
      });
    },
    setError(err) {
      this.error = err;
      setTimeout(() => {
        this.error = "";
      }, 5000);
    },
  },
};
</script>

<style scoped>
.btn-login {
  color: blue;
  margin-left: 5px;
}
.aa-error {
  color: red;
  padding: 10px;
}
</style>